import { defineComponent } from "vue";
import InlineSvg from "vue-inline-svg";

import callSvg from "@/assets/img/sim/call.svg";
import messageSvg from "@/assets/img/sim/message.svg";
import dataSvg from "@/assets/img/sim/data.svg";
import remoteSvg from "@/assets/img/sim/remote-control.svg";

export default defineComponent({
  template: `  
      <div class="card modal-selected-package">
        <div class="card-heading bg-primary-light">
          <h4 class="mb-0">
            Vybraný balíček —
            <span class="modal-name">{{ groupName }}</span> za
            <span class="modal-price">{{ priceVat }}</span> Kč měsíčně
          </h4>
        </div>
        <div class="card-body padding-small">
          <ul class="mb-0">
            <template v-if="includeIptv">
              <li class="d-flex">
              <inline-svg
                :src="remoteSvg"
                  class="svg-icon text-primary"
              ></inline-svg>
                <div class="ml-2 modal-channels">
                <strong>TV s 100+</strong> stanicemi
                </div>
              </li>
              <hr style="margin-bottom: 1rem; margin-top: 1rem;" />
            </template>
            <li class="d-flex">
            <inline-svg
              :src="callSvg"
                class="svg-icon text-primary"
            ></inline-svg>
              <div class="ml-2 modal-minutes">
                <span v-if="!this.containsInfiniteVoice">
                  <span v-if="this.tariff.incl_min !== 0">
                    <strong>{{ tariff.incl_min }}</strong> minut
                  </span>
                  <span v-if="this.tariff.incl_min === 0">
                    <strong>1.50 Kč</strong> / min
                  </span>
                </span>
                <span v-if="this.containsInfiniteVoice">
                  <strong>Neomezeně</strong> minut
                </span>
                <span v-if="this.containsInfiniteVoiceInNetwork">
                  + neomezeně v síti PODA
                </span>
              </div>
            </li>
            <li class="d-flex">
            <inline-svg
            :src="messageSvg"
              class="svg-icon text-primary"
          ></inline-svg>
              <div class="ml-2 modal-sms">
                <span v-if="this.tariff.incl_sms !== 0">
                  <strong>{{ tariff.incl_sms }}</strong> SMS
                </span>
                <span v-if="this.tariff.incl_sms === 0">
                  <strong>1.50 Kč</strong> / SMS
                </span>
              </div>
            </li>
            <li class="d-flex">
          <inline-svg
          :src="dataSvg"
            class="svg-icon text-primary"
        ></inline-svg>
              <div class="ml-2 modal-data">
                {{ tariff.data }}
              </div>
            </li>
          </ul>
        </div>
        <div
            class="card-footer bg-light text-sm"
            v-if="tariff.program_type === 'klient'"
        >
          <div class="modal-type">
            Speciální nabídka je platná pro zákazníky PODA.
          </div>
        </div>
    </div>
    `,
  name: "TariffOverviewCard",
  props: {
    tariff: {
      type: Object,
    },
    includeIptv: {
      type: Boolean,
      default: false,
      required: false,
    },
    iptvPrice: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  computed: {
    containsInfiniteVoice() {
      return this.tariff.group_id === 1;
    },
    containsInfiniteVoiceInNetwork() {
      return this.tariff.group_id === 4;
    },
    groupName() {
      if (this.includeIptv) return "IPTV + " + this.tariff.group_name;
      return this.tariff.group_name;
    },
    priceVat() {
      if (this.includeIptv) return this.iptvPrice + this.tariff.price_vat;
      return this.tariff.price_vat;
    },
  },
  data() {
    return {
      callSvg: callSvg,
      messageSvg: messageSvg,
      dataSvg: dataSvg,
      remoteSvg: remoteSvg,
    };
  },
  components: {
    InlineSvg,
  },
});
